// Externe Bibliotheken
import React, { Component, useContext } from 'react';
import { Link } from 'react-router';
import axios from 'axios';
import _ from 'lodash';

// Interne Module
import { tripStartCountdown } from '@/_helper/bookingDetailsHelper';
import { convertDate, createPaxAges } from '@/_helper/mapper';
import * as storage from '@/_helper/storage';
import { buildPostRequest } from '@/_helper/apiHelper';
import { transferLinks } from '@/_config/transfer';

// Komponenten
import DocumentTile from '@/pages/documents';
import { Icon } from '@/comp/icon/icon.tsx';
import OverlayModal from '@/comp/overlayModal/overlayModal';
import { AppContext } from '@/context/AppContext.tsx';
import InfoCard from '@/comp/ui/infoCard/infoCard.tsx';

// Content
import transferPickupHintContent from '@/_data/cruise/transferContent.tsx';

class TransferDetails extends Component {
    state = {
        loadingTransferOffers: true,
        transferDetailsModal: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            travelType: props.travelType,
        };

        this.errorHandling = this.errorHandling.bind(this);
    }
    static contextType = AppContext;

    componentDidMount() {
        this.setState(
            {
                bookingData: this.props.bookingData,
            },
            () => {
                if (this.state.bookingData) {
                    if (storage.get('transferOffers')) {
                        this.setState({ loadingTransferOffers: false });
                    } else {
                        this.transferRequest();
                    }
                }
            }
        );
    }

    transferRequest() {
        let searchParams = this.state.bookingData.data.searchParams;
        let hotelSupplier = '';
        let handlingSupplier = '';

        if (searchParams.adults > 0 && this.state.bookingData.allowTransfer) {
            const sendData = {
                requestType: 'searchExtra',
                travelType: 'transfer',
                regionCode: searchParams.destination,
                arrivalAirportCode: searchParams.retAirport,
                travelStart: convertDate(searchParams.depDate),
                travelEnd: convertDate(searchParams.retDate),
                paxAges: createPaxAges(searchParams.paxAges),
                hotelCodeList: [searchParams.hotelCode],
                filterTags: [],
                departureTime: searchParams.transferDepartureTime,
                returnTime: searchParams.transferArrivalTime,
                amountAdults: searchParams.adults,
                clientId: 'customerarea',
                hotelSupplier: hotelSupplier,
                handlingSupplier: handlingSupplier,
            };

            axios(buildPostRequest(window.$requestUrl, '/searchExtra', JSON.stringify(sendData)))
                .then((response) => response)
                .then((data) => {
                    let bookingData = this.state.bookingData;

                    if (bookingData) {
                        if (data && data.data?.data?.transferOffers) {
                            storage.set('transferOffers', {
                                data: data.data.data,
                            });
                        } else {
                            bookingData.data.allowTransfer = false;
                        }

                        storage.set('bookingData', bookingData);
                        this.setState({
                            bookingData: bookingData,
                            loadingTransferOffers: false,
                        });
                    } else {
                        this.setState((state) => {
                            state.bookingData.data.allowTransfer = false;
                            state.loadingTransferOffers = false;
                            return state;
                        });
                    }
                })
                .catch((error) => this.setState({ error, loadingTransferOffers: false }));
        } else {
            this.setState({ loadingTransferOffers: false });
        }
    }

    railAndFlyRequest() {
        let railAndFlyData = undefined;

        if (this.state.bookingData !== null && this.state.bookingData !== undefined) {
            if (this.state.bookingData.data.serviceInformation.railAndFly !== undefined) {
                railAndFlyData = this.state.bookingData.data.serviceInformation.railAndFly;
            }

            if (this.state.bookingData.bookedService !== undefined) {
                if (this.state.bookingData.bookedService.railAndFly !== undefined) {
                    railAndFlyData = [];
                    _.forEach(this.state.bookingData.bookedService.railAndFly, function (v) {
                        railAndFlyData.push(v.data);
                    });
                }
            }
        }

        return railAndFlyData;
    }

    errorHandling(props) {
        if (props) {
            this.setState({
                error: true,
            });
        }
    }

    getTransferStatus() {
        if (this.state.bookingData === undefined) {
            return false;
        }

        const { data } = this.state.bookingData;

        const transferMapper =
            window.$content.mappingTransfer[this.state.travelType]?.[
                data.frontendParams.transferDetails?.tariff.toLowerCase() || ''
            ];
        let tripStartsIntheNext30Days = tripStartCountdown(data.searchParams.depDate) <= 30;

        let transferStatus = 'transferNotBooked';
        switch (true) {
            case data.frontendParams.transferDetails !== undefined &&
                transferMapper !== undefined &&
                (!tripStartsIntheNext30Days || data.frontendParams?.price?.open !== 0):
                transferStatus = 'transferWarning';
                break;
            case data.frontendParams.transferDetails !== undefined &&
                tripStartsIntheNext30Days &&
                data.frontendParams?.price?.open === 0 &&
                transferMapper !== undefined:
                transferStatus = 'transferDocument';
                break;
            default:
        }

        let railFlyStatus = 'railFlyWarning';
        switch (true) {
            case this.railAndFlyRequest() === undefined:
                if (data?.allowRailAndFly) {
                    railFlyStatus = 'railFlyNotBooked';
                } else {
                    railFlyStatus = 'railFlyNotAllowed';
                }
                break;
            case tripStartsIntheNext30Days && data.frontendParams?.price?.open === 0:
                railFlyStatus = 'railFlyDocument';
                break;
            default:
        }

        return {
            transferStatus,
            railFlyStatus,
        };
    }

    transferDetails(transferStatus) {
        const { data } = this.state.bookingData;

        return transferStatus === 'transferWarning' ? (
            <button
                className="button-element button-ghost"
                onClick={() => {
                    this.setState({
                        transferWarning: this.state.transferWarning ? !this.state.transferWarning : true,
                    });
                }}>
                Transferdetails ansehen
            </button>
        ) : transferStatus === 'transferDocument' ? (
            <button
                className="button-element button-ghost"
                onClick={() => {
                    this.setState({ transferDetailsModal: true });
                }}>
                Transferdetails/-zeiten ansehen
            </button>
        ) : (
            <>
                {data.allowTransfer ? (
                    <Link
                        rel="noopener noreferrer"
                        to={`/${transferLinks[this.state.travelType]}`}
                        target="_blank"
                        className="button-element button-ghost">
                        Transfer buchen
                    </Link>
                ) : (
                    <>Keine Transfer möglich</>
                )}
            </>
        );
    }

    railFlyDetails(railFlyStatus) {
        return (
            <>
                {railFlyStatus === 'railFlyWarning' ? (
                    <>
                        <div
                            className="button-element button-ghost"
                            onClick={() => {
                                this.setState({
                                    railFlyWarning: this.state.railFlyWarning ? !this.state.railFlyWarning : true,
                                });
                            }}>
                            Zugverbindung ansehen
                        </div>
                    </>
                ) : railFlyStatus === 'railFlyDocument' ? (
                    <DocumentTile
                        service="railAndFlyVoucher"
                        name="traveldocument"
                        documentType="railAndFlyVoucher"
                        label="Zugverbindung ansehen"
                        label_loading="Zugverbindung wird geladen"
                        link="true"
                        errorHandling={this.errorHandling}
                    />
                ) : (
                    <Link
                        rel="noopener noreferrer"
                        to={'/zug-zum-flug'}
                        target="_blank"
                        className="button-element button-ghost">
                        Zug buchen
                    </Link>
                )}
            </>
        );
    }

    render() {
        const status = this.getTransferStatus();
        const transferStatus = status.transferStatus;
        const railFlyStatus = status.railFlyStatus;

        if (
            this.props.bookingState === 'OK' &&
            this.state.bookingData !== undefined &&
            (railFlyStatus !== 'railFlyNotAllowed' ||
                this.state.bookingData.data.allowTransfer ||
                transferStatus !== 'transferNotBooked')
        ) {
            return (
                <div className="item transfer">
                    <Icon name="airportShuttle300" size={30} ariaHidden />
                    <div>
                        {this.state.loadingTransferOffers ? (
                            <div className="lazy-load-background">
                                <span></span>
                                <span></span>
                            </div>
                        ) : (
                            <>
                                <div>
                                    {(this.state.bookingData.data.allowRailAndFly ||
                                        railFlyStatus !== 'railFlyNotAllowed') && (
                                        <>
                                            {railFlyStatus === 'railFlyNotBooked' ? 'Ohne ' : 'Mit '}
                                            Zug zum Flug
                                        </>
                                    )}
                                    {(this.state.bookingData.data.allowTransfer ||
                                        transferStatus !== 'transferNotBooked') && (
                                        <>
                                            {(this.state.bookingData.data.allowRailAndFly ||
                                                railFlyStatus !== 'railFlyNotAllowed') && <>&nbsp;&middot;&nbsp;</>}
                                            {transferStatus === 'transferNotBooked' ? 'Ohne ' : 'Mit '} Transfer
                                        </>
                                    )}
                                </div>

                                <div className="user-interaction">
                                    {(this.state.bookingData.data.allowRailAndFly ||
                                        railFlyStatus !== 'railFlyNotAllowed') && (
                                        <>{this.railFlyDetails(railFlyStatus)}</>
                                    )}

                                    {(this.state.bookingData.data.allowTransfer ||
                                        transferStatus !== 'transferNotBooked') && (
                                        <>{this.transferDetails(transferStatus)}</>
                                    )}
                                </div>
                                {this.state.transferDetailsModal && (
                                    <TransferDetailsOverlay
                                        handleError={this.errorHandling}
                                        toggleModal={() =>
                                            this.setState({
                                                transferDetailsModal: !this.state.transferDetailsModal,
                                            })
                                        }
                                    />
                                )}

                                {railFlyStatus === 'railFlyWarning' && this.state.railFlyWarning && (
                                    <div className="booking-alert transport-details">
                                        <Icon name="info" ariaHidden />
                                        Sie können Ihre Details zur Zugverbindung in Ihren Reiseunterlagen nachlesen.
                                        Diese werden frühesten 30 Tage vor Abreisedatum bei vollständiger Zahlung der
                                        Buchung angezeigt.
                                        <Icon
                                            role="button"
                                            name="close"
                                            ariaLabel="schließen"
                                            className="icon-close"
                                            onClick={() => {
                                                this.setState({ railFlyWarning: false });
                                            }}
                                        />
                                    </div>
                                )}
                                {(this.state.bookingData.data.allowTransfer ||
                                    transferStatus !== 'transferNotBooked') &&
                                    this.state.transferWarning && (
                                        <div className="booking-alert transport-details">
                                            <Icon name="info" ariaHidden />
                                            Sie können Ihre Details zum Transfer in Ihren Reiseunterlagen nachlesen.
                                            Diese werden frühesten 30 Tage vor Abreisedatum bei vollständiger Zahlung
                                            der Buchung angezeigt.
                                            <Icon
                                                role="button"
                                                name="close"
                                                ariaLabel="schließen"
                                                className="icon-close"
                                                onClick={() => {
                                                    this.setState({ transferWarning: false });
                                                }}
                                            />
                                        </div>
                                    )}
                                {this.state.error && (
                                    <div className="booking-alert transport-details">
                                        <Icon name="info" ariaHidden />
                                        Hier ist wohl etwas schiefgelaufen! Bitte versuchen Sie es erneut oder wenden
                                        Sie sich an unser Serviceteam.
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            );
        }
    }
}

const TransferDetailsOverlay = ({ handleError, toggleModal }) => {
    const appContext = useContext(AppContext);
    const transferDetails = appContext?.bookingData?.data?.frontendParams?.transferDetails;

    return (
        <OverlayModal
            name="transfer-details"
            displayName="Transferdetails und Abholzeiten"
            scrollable={false}
            toggleModal={toggleModal}>
            <div>
                {transferDetails?.transferTimeKnowable ? (
                    transferDetails.inboundTransferPickupTime ? (
                        <>
                            <p className="info-container">
                                Abholdatum:{' '}
                                <b>
                                    {new Date(transferDetails.transferPickupDate).toLocaleDateString('de-DE', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                    })}
                                </b>
                                <br />
                                Abholzeit: <b>{transferDetails.inboundTransferPickupTime} Uhr</b>
                                <br />
                                Abholort:{' '}
                                <b>
                                    {transferDetails.transferPickupMeetingPointType === 1
                                        ? 'Am Haupteingang Ihres Hotels'
                                        : transferDetails.transferPickupMeetingPoint}
                                </b>
                            </p>
                            <p>Weitere Informationen sowie wichtige Telefonnummern finden Sie im Transfer-Voucher:</p>
                        </>
                    ) : (
                        <p>
                            Ihre Transferzeit liegt uns leider noch nicht vor. Bitte wenden Sie sich bei dringenden
                            Fragen an die Kontaktdaten (Telefonnummer), die Sie im Transfer-Voucher finden.
                        </p>
                    )
                ) : (
                    <>
                        <p>
                            Die Transferzeiten können Sie frühestens ab 24 Stunden vor Abflug hier einsehen (und
                            erhalten diese zusätzlich noch per E-Mail).
                        </p>
                        <p>Weitere Informationen sowie wichtige Telefonnummern finden Sie im Transfer-Voucher:</p>
                    </>
                )}

                {appContext.travelType === 'cruise' && (
                    <InfoCard type="small">
                        <div>
                            <h4>Hinweis zum Rücktransfer</h4>
                            {transferPickupHintContent}
                        </div>
                    </InfoCard>
                )}
                <DocumentTile
                    service="transferVoucher"
                    name="traveldocument"
                    documentType="transferVoucher"
                    label="Transfer-Voucher"
                    label_loading="Transferdetails werden geladen"
                    errorHandling={handleError}
                />
            </div>
        </OverlayModal>
    );
};

export default TransferDetails;
